export class LoggingService {
    logStatusChange(status: string) {
        console.log('A server status changed, new status: ' + status);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/services/logging.service.ts